import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=db1a992e&scoped=true"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"
import style0 from "./BasePage.vue?vue&type=style&index=0&id=db1a992e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1a992e",
  null
  
)

export default component.exports